/**
 * Lazy loader for html2canvas library.
 *
 * html2canvas is a browser-only library that self-initializes on import,
 * which breaks tests in Node environment. This wrapper defers loading
 * until actually needed.
 *
 * Usage:
 *   import { loadHtml2Canvas } from '@/utils/html2canvas-loader';
 *
 *   async function captureElement(element) {
 *     const html2canvas = await loadHtml2Canvas();
 *     return html2canvas(element, options);
 *   }
 */
import { createLazyModule } from './lazy';

export const html2canvasModule = createLazyModule(async () => {
  const { default: html2canvas } = await import('html2canvas');
  return { html2canvas };
});

export const loadHtml2Canvas = async () => {
  const { html2canvas } = await html2canvasModule.load();
  return html2canvas;
};

export const isHtml2CanvasLoaded = html2canvasModule.isLoaded;
export const resetHtml2Canvas = html2canvasModule.reset;
